import { render, staticRenderFns } from "./ViewHistory.vue?vue&type=template&id=af1f6170&scoped=true&"
import script from "./ViewHistory.vue?vue&type=script&lang=js&"
export * from "./ViewHistory.vue?vue&type=script&lang=js&"
import style0 from "./ViewHistory.vue?vue&type=style&index=0&id=af1f6170&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1f6170",
  null
  
)

export default component.exports